import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GoCardlessPage } from './gocardless.page';

const routes: Routes = [
  {
    path: '',
    component: GoCardlessPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class GoCardlessPageRoutingModule {}
